import { useState, useCallback } from 'react';

export interface ToastMessage {
  id: string;
  message: string;
  type: 'success' | 'error' | 'info';
}

let toastListeners: Array<(toast: ToastMessage) => void> = [];

export const showToast = (message: string, type: 'success' | 'error' | 'info' = 'success') => {
  const toast: ToastMessage = {
    id: `toast-${Date.now()}-${Math.random()}`,
    message,
    type,
  };
  
  toastListeners.forEach(listener => listener(toast));
};

export const useToastManager = () => {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  const addToast = useCallback((toast: ToastMessage) => {
    setToasts(prev => [...prev, toast]);
  }, []);

  const removeToast = useCallback((id: string) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  const registerListener = useCallback(() => {
    toastListeners.push(addToast);
    return () => {
      toastListeners = toastListeners.filter(listener => listener !== addToast);
    };
  }, [addToast]);

  return { toasts, removeToast, registerListener };
};

